import * as React from 'react';

/**
 * TODO consider getting rid from wrapper variant
 * @ignore - internal component.
 */
export const WrapperVariantContext = /*#__PURE__*/React.createContext(null);
/**
 * @ignore - internal component.
 */

export const IsStaticVariantContext = /*#__PURE__*/React.createContext(false);